import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class Services extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      row: [],
    }

   // console.log('sss');

  }

  mount() {


  
     _each(this.ref.row, (item) => {

       // console.log(item);

       $(item).on('click', (e) => {

       //  console.log('click');
         $('.is-opened').not(item).removeClass('is-opened')
         $(item).toggleClass('is-opened')
       })
     })


 



 }

  unmount() {




  }
}




module.exports = Services
